<template>
  <page-wrap wrapClass="register">
    <land-box>
      <div slot="main" class="form-wrap" v-show="!dialogVisible">
        <el-tabs
          v-model="loginBy"
          :stretch="true"
          :class="loginBy"
          @tab-click="switchTab"
        >
          <el-tab-pane label="密码登录" name="account">
            <el-form
              ref="accountForm"
              :rules="accountRules"
              :model="accountForm"
              hide-required-asterisk
            >
              <el-form-item class="form-item" prop="username">
                <el-input
                  v-model.trim="accountForm.username"
                  auto-complete="off"
                  type="text"
                  placeholder="请输入账号、手机号、邮箱"
                  readonly
                  onfocus="this.removeAttribute('readonly');"
                />
              </el-form-item>
              <el-form-item class="form-item" prop="password">
                <el-input
                  v-model="accountForm.password"
                  auto-complete="off"
                  placeholder="请输入密码"
                  @keyup.enter.native="handleLogin('account')"
                  show-password
                />
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="短信登录" name="sms">
            <el-form
              ref="smsForm"
              :rules="smsRules"
              :model="smsForm"
              hide-required-asterisk
            >
              <el-form-item class="form-item" prop="phoneNum">
                <el-input
                  v-model.trim="smsForm.phoneNum"
                  type="text"
                  placeholder="请输入手机号"
                />
              </el-form-item>
              <el-form-item prop="verifyCode" class="form-item vcode-item">
                <div class="ou-expand">
                  <el-input
                    v-model.trim="smsForm.verifyCode"
                    type="text"
                    placeholder="请输入验证码"
                  />
                </div>
                <el-button
                  class="vcode-btn"
                  :class="[vCodeBtnDisabled ? 'biger' : '']"
                  @click="openBioReg"
                  :disabled="vCodeBtnDisabled"
                  >{{ vCodeBtnText }}
                </el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div slot="foot" class="foot-wrap" v-if="!dialogVisible">
        <el-button
          :loading="regLoading"
          type="primary"
          class="submit-btn"
          @click.native.prevent="handleLogin(loginBy)"
        >
          <span v-if="!regLoading">登录</span>
          <span v-else>登 录 中...</span>
        </el-button>
        <div class="form-bottom ou-flex-lr">
          <span class="web-link" @click="goRegister">
            没有账号，立即注册>
          </span>
          <span class="web-link" @click="goFindBack"> 忘记密码？ </span>
        </div>
        <div class="login_row">
          <div class="login_span"></div>
          <div class="login_title">其他登录方式</div>
          <div class="login_span"></div>
        </div>
        <div class="login_row">
          <el-image
            class="land-image"
            :src="require('@/assets/images/land-logo.png')"
            fit="cover"
          >
          </el-image>
          <div @click="appBut" class="land-titles">开放云书院APP登录</div>
        </div>
      </div>
      <div slot="main" class="form-wrap" v-show="dialogVisible">
        <appLogin ref="appBox" :dataMsg="dialogVisible"></appLogin>
        <div class="login_row">
          <el-image
            class="land-image"
            :src="require('@/assets/images/land-logo.png')"
            fit="cover"
          >
          </el-image>
          <div class="land-titles">开放云书院APP扫一扫登录</div>
        </div>
        <div class="back_" @click="appClose">返回账号密码登录></div>
      </div>
    </land-box>
    <verify
      ref="bioReg"
      :mode="'pop'"
      :captcha-type="'blockPuzzle'"
      :img-size="{ width: '330px', height: '155px' }"
      @success="bioRegPass"
    />
    <el-dialog title="提示" :visible.sync="dialogVisibles" width="30%">
      <span
        >您的密码已长时间未修改，为了保证您的账户安全，请及时修改密码哦^_^</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancle">取 消</el-button>
        <el-button type="primary" @click="toEditPassword">确 定</el-button>
      </span>
    </el-dialog>
  </page-wrap>
</template>

<script>
import { mapActions } from "vuex";
import PageWrap from "./components/PageWrap";
import appLogin from "./components/appLogin";
import LandBox from "./components/LandBox";
import Verify from "@/components/verifition/Verify";
import { encrypt } from "@/utils/jsencrypt";
import { apiSendMsgCode, apiGetAuthConfig, strategy } from "@/api/user/login";
import storage from "@/utils/cache";
let { local: localCache } = storage;

const mobile_reg =
  /^1(3[0-9]|4[01456879]|5[0-3,5-9]|6[2567]|7[0-8]|8[0-9]|9[0-3,5-9])\d{8}$/;

export default {
  name: "login",
  components: { PageWrap, LandBox, Verify, appLogin },
  data() {
    return {
      dialogVisibles: false,
      loginBy: "account",
      smsForm: {
        phoneNum: "",
        verifyCode: "",
      },
      accountForm: {
        username: "",
        password: "",
      },
      verifyKey: "",
      vCodeBtnDisabled: false,
      canResendSeconds: 0,
      timer: null,
      hasAgree: false,
      bioRegCallBy: "",
      bioVerification: "",
      regLoading: false,
      smsRules: {
        phoneNum: [
          { required: true, trigger: "blur", message: "请输入手机号" },
          {
            pattern: mobile_reg,
            trigger: "blur",
            message: "请输入正确的手机号码",
          },
        ],
        verifyCode: [
          { required: true, trigger: "blur", message: "请输入验证码" },
        ],
      },
      accountRules: {
        username: [
          {
            required: true,
            trigger: "blur",
            message: "请输入您的账号、手机号或邮箱",
          },
          {
            min: 2,
            max: 20,
            message: "账号长度必须介于 2 和 20 之间",
            trigger: "blur",
          },
          {
            pattern: /^[^\u4e00-\u9fa5]+$/,
            message: "账号不能为汉字",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, trigger: "blur", message: "请输入您的密码" },
          { min: 6, max: 20, trigger: "blur", message: "密码应为6-20个字符" },
          // { min: 5, max: 20, validator: this.validPassword, trigger: 'blur' },
        ],
      },
      isPwdEncrypt: "default",
      isValidateBlock: "default",
      dialogVisible: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 缓存除了注册页和找回密码页的路由
      let path = from.path,
        query = from.query || {};
      let ignoreList = ["/register", "/findbackstep"];
      if (!ignoreList.includes(path)) {
        let afterLoginWorker = { path, query };
        localCache.setJSON("AFTER_LOGIN_WORKER", afterLoginWorker);
      }
    });
  },
  methods: {
    ...mapActions("user", ["addUserActivation"]),
    /*    validPassword(rule, value, callback) {
      let reg = /(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{6,20}/
      if (!reg.test(value)) {
        callback(new Error('密码必须包含大小写字母、数字、特殊字符，6-20个字符'))
      } else {
        callback()
      }
    },*/
    //长时间未修改密码点确定
    toEditPassword() {
      this.$router.push("/user/accountManage");
    },
    cancle() {
      this.loginSuccessful()
    },
    appBut() {
      this.dialogVisible = true;
    },
    appClose() {
      this.dialogVisible = false;
    },
    switchTab(tab, event) {},
    // 事件：获取验证码按钮
    openBioReg() {
      // 先校验手机号, 通过则打开滑块验证控件
      this.$refs.smsForm.validateField("phoneNum", (error, field) => {
        if (!error.length) {
          if (this.isValidateBlock) {
            this.bioRegCallBy = "sms";
            this.$refs.bioReg.show();
          } else {
            this.getVerifyCode();
          }
        }
      });
    },
    // 滑块式生物识别, 通过则请求短信验证码
    bioRegPass(result) {
      this.bioVerification = result.captchaVerification;
      if (this.bioRegCallBy === "sms") {
        this.getVerifyCode(result.captchaVerification);
      } else if (this.bioRegCallBy === "account") {
        this.$refs.accountForm.validate().then((_) => {
          let { username: userName, password } = this.accountForm;
          let data = {
            type: "account",
            params: {
              userName,
              password: this.isPwdEncrypt ? encrypt(password) : password,
              customType: "pc",
              verification: result.captchaVerification,
            },
          };
          this.$store.dispatch("Login", data).then(() => {
            // 判断用户密码是否需要重置
            strategy().then((res) => {
              if (res.data.isPasswordExpired) {
                this.dialogVisibles = true;
              } else {
                // TODO：登录后的特殊逻辑
                this.loginSuccessful();
              }
            });
          });
        });
      }
    },
    // 请求短信验证码
    getVerifyCode(bioVerification) {
      if (this.isValidateBlock && !bioVerification) {
        this.$message.error("安全验证失败");
        return;
      }
      // 因为前置逻辑验证过这里可不校验手机，健壮性起见二次验证
      this.$refs.smsForm.validateField("phoneNum", (error, field) => {
        if (!error.length) {
          let params = {
            phoneNum: this.smsForm.phoneNum,
            type: 4,
          };
          params = this.isValidateBlock
            ? { ...params, verification: bioVerification }
            : params;
          apiSendMsgCode(params).then((res) => {
            console.log("res,", res);
            // 请求验证码成功则开启重发保护倒计时
            let { key, retrySendIntervalSeconds } = res.data;
            this.verifyKey = key;
            this.startCountdown(retrySendIntervalSeconds);
          });
        }
      });
    },
    // 验证码重发保护
    startCountdown(seconds) {
      const _this = this;
      this.canResendSeconds = seconds || 60;
      this.vCodeBtnDisabled = true;
      this.timer = setInterval(() => {
        if (_this.canResendSeconds === 1) {
          _this.vCodeBtnDisabled = false;
          clearInterval(_this.timer);
          _this.timer = null;
        }
        _this.canResendSeconds--;
      }, 1000);
    },
    handleLogin(type) {
      if (type === "sms") {
        this.$refs.smsForm.validate().then((_) => {
          let { phoneNum, verifyCode: code } = this.smsForm;
          let data = {
            type,
            params: {
              phoneNum,
              code,
              key: this.verifyKey,
              customType: "pc",
            },
          };

          this.$store.dispatch("Login", data).then(() => {
            // TODO：登录后的特殊逻辑
            this.loginSuccessful();
          });
        });
      } else if (type === "account") {
        this.$refs.accountForm.validate().then((_) => {
          if (this.isValidateBlock) {
            this.bioRegCallBy = "account";
            this.$refs.bioReg.show();
          } else {
            let { username: userName, password } = this.accountForm;
            let data = {
              type: "account",
              params: {
                userName,
                password: this.isPwdEncrypt ? encrypt(password) : password,
                customType: "pc",
              },
            };
            this.$store.dispatch("Login", data).then(() => {
              // TODO：登录后的特殊逻辑
              this.loginSuccessful();
            });
          }
        });
      }
    },
    goRegister() {
      this.$router.push("/register");
    },
    loginSuccessful() {
      let { redirect,redirectPath } = this.$route.query;
      let queryParams = this.$store.getters.redirectParams || {};
      let path=redirect || redirectPath || "/index";
      console.log("🚀 ~ loginSuccessful ~ queryParams:",path, queryParams)
      this.$router
        .push({
          path: path,
          query: {
            ...queryParams,
          },
        })
        .then(() => {
          this.$store.commit("SET_REDIRECTPARAMS", "");
        });

      
      // let url = localStorage.getItem("YSY-ROUTER-fullPath") || "";
      // let obj = {};
      // if (url.split("?")[1]) {
      //   let keyValue = url.split("?")[1].split("&");
      //   for (let i = 0; i < keyValue.length; i++) {
      //     let item = keyValue[i].split("=");
      //     let key = item[0];
      //     let value = item[1];
      //     obj[key] = value;
      //     // obj.push(value);
      //   }
      // }
      // this.$router.push({
      //   path: url.split("?")[0],
      //   query: obj,
      // });
    },
    goFindBack() {
      this.$router.push("/findbackstep");
    },
  },
  created() {},
  mounted() {
    apiGetAuthConfig().then((res) => {
      Object.assign(this.$data, res.data);
    });
  },
  watch: {},
  computed: {
    vCodeBtnText() {
      return this.vCodeBtnDisabled
        ? this.canResendSeconds + "秒后重新获取"
        : "获取验证码";
    },
  },
};
</script>

<style scoped lang="scss">
.form-wrap::v-deep {
  .el-tabs__header {
    margin-bottom: 42px;
  }
  .el-tabs__nav.is-stretch {
    background-color: #ffffff;
  }
  .el-tabs__active-bar {
    width: 148px !important;
  }
  .sms {
    .el-tabs__active-bar {
      transform: translateX(246px) !important;
    }
  }
  .account {
    .el-tabs__active-bar {
      transform: translateX(0px) !important;
    }
  }
  .el-tabs__item {
    font-size: 32px;
    height: 48px;
    letter-spacing: 4px;
    padding: 0 5px !important;
    &:nth-child(2) {
      text-align: left;
    }
    &:first-child {
      text-align: left;
    }
    &:last-child {
      text-align: right;
    }
  }
}
.foot-wrap ::v-deep {
  margin-top: 1vh;
}
.login_row {
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: center;
  margin-top: 20px;
  cursor: pointer;
}
.login_span {
  width: 120px;
  height: 1px;
  margin-top: 12px;
  background-color: #e2e2e2;
}
.login_title {
  padding: 0 20px;
}
.land-image {
  width: 22px;
  height: 22px;
  background-color: #2e9adb;
  padding: 5px;
  border-radius: 50%;
}
.land-titles {
  height: 32px;
  line-height: 32px;
  margin-left: 10px;
}
.back_ {
  margin: 10px auto 0 auto;
  text-align: center;
  cursor: pointer;
}
</style>
